import React from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import PerformanceHistory from './PerformanceHistory';
import RatingMetrics from './RatingMetrics';

const DrivePerformanceChart = () => {
  const { driverId } = useParams();

  return (
    <Container>
      <PerformanceHistory
        baseUrl={`api/v1/dispatchers/${driverId}/performance-insights`}
      />
      <RatingMetrics
        baseUrl={`api/v1/dispatchers/${driverId}/rating-metrics`}
      />
    </Container>
  );
};

export default DrivePerformanceChart;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
